import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import TourStepContent from "./wrapper";
import { simulateElementClick, simulateInlineEdit, switchToLevel, clearTyping } from "./helpers";
import { goToPage } from "../../../editor/events";

/**
 * Line number (0-indexed) of "title: Solar Power" in DEMO_PRESENTATION.
 * Page index 2 (1-based) in the preview.
 */
const DEMO_TITLE_LINE = 4;
const DEMO_TITLE_PAGE = 2;

const editElement = (hostId: string): StepType[] => [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => <strong>{text.tourSteps.quickEdits}</strong>}
			/>
		),
		position: "center",
	},
	{
		selector: "#tab-edit-element",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.editElementIntro}
						<br />
						<br />
						{text.tourSteps.editElementClick}
					</span>
				)}
			/>
		),
		action: () => {
			switchToLevel(2);
			goToPage(hostId, "QP", DEMO_TITLE_PAGE);
		},
	},
	{
		selector: "#panel-edit",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.editElementTry}
						<br />
						<br />
						{text.tourSteps.editElementInlineEditor}
					</span>
				)}
			/>
		),
		action: () => {
			simulateElementClick(DEMO_TITLE_LINE, DEMO_TITLE_PAGE, "title");
			setTimeout(() => goToPage(hostId, "QP", DEMO_TITLE_PAGE), 300);
		},
	},
	{
		selector: "#panel-edit",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.editElementWatch}
						<br />
						<br />
						{text.tourSteps.editElementRealtime}
					</span>
				)}
			/>
		),
		action: () => {
			// "title: Solar Power" → replace "Solar Power" (starts at col 7)
			simulateInlineEdit(text.tourSteps.editElementReplacement, 7, hostId, DEMO_TITLE_PAGE);
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent
				description={() => text.tourSteps.editElementReflected}
			/>
		),
		position: "left",
	},
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.editElementPerfectFor}
						<br />
						<br />
						{text.tourSteps.editElementFixTypos}
						<br />
						{text.tourSteps.editElementAdjustWording}
						<br />
						{text.tourSteps.editElementChangeElements}
						<br />
						<br />
						{text.tourSteps.editElementNoNeedToFind}
					</span>
				)}
			/>
		),
		position: "center",
		action: () => {
			clearTyping();
		},
	},
];

export default editElement;
